import { ENV_TOGGLE_BLACKLIST } from '@/constants/constants';
import { useAuthDetails } from '@/queries/useAuth';
import { containsUUID } from '@/utils/utils';
import { useAuth0 } from '@auth0/auth0-react';
import { useLocation } from 'react-router-dom';
import { EnvironmentToggleHelper } from '../types';

export const useEnvironmentToggle = (): EnvironmentToggleHelper => {
  const { pathname } = useLocation();
  const { isAuthenticated, isLoading } = useAuth0();
  const { data: user, isFetching } = useAuthDetails();

  const isLiveEnabled = user?.isLiveEnabled || false;
  const isPostpaidAccount = !user?.merchantPaymentType || user?.merchantPaymentType === 'postpaid';
  const isPrepaidAccount = user?.merchantPaymentType === 'prepaid';

  const isPathBlacklisted = (): boolean => {
    return ENV_TOGGLE_BLACKLIST.some(item => pathname.includes(item.id));
  };

  const isWhitelisted = !containsUUID(pathname) && !isPathBlacklisted();
  return {
    isLiveEnabled,
    isWhitelisted,
    isLoading: !isAuthenticated || isLoading || isFetching,
    liveStatus: user?.liveStatus || null,
    isPostpaidAccount,
    isPrepaidAccount,
  };
};
